// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://jczslnyxdnlwkvoqjivl.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpjenNsbnl4ZG5sd2t2b3FqaXZsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg2NTI2MTMsImV4cCI6MjA4NDIyODYxM30.c-MIDVqCRGPByGhyaALGvI0q8Y1x5k3NV2zutPH2iL0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});